import { Select, Space } from "antd";
import { CardContainer } from "components/elements";
import EmployeeSalaryTaxTable from "components/table/EmployeeSalaryTaxTable";

function EmployeeSalaryTax({
  pagination = {},
  isLoading = false,
  accumulateList = [],
  selectedYear = null,
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  onYearChange = () => { },
}) {
  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Select
        value={selectedYear}
        defaultValue={selectedYear}
        onChange={onYearChange}
        style={{ width: 120 }}
        options={[]}
        size="large"
      />
      <EmployeeSalaryTaxTable
        isLoading={isLoading}
        dataSource={accumulateList}
        pagination={pagination}
        onEdit={onEdit}
        onDelete={onDelete}
        onChange={onChange}
      />
    </Space>
  );
}

export default EmployeeSalaryTax;
